
import { Component, Injector, OnInit } from '@angular/core';
import { LogService } from 'tnx-admin-service/slog/services';
import {
    ComponentContextService, DataFormBase, EventData, FormControlBase, TableSchema, TextAreaControlSchema, TextControlSchema
} from 'tnx-shared';

@Component({
    selector: 'log-form',
    templateUrl: './log-form.component.html',
    styleUrls: ['./log-form.component.scss'],
    providers: [ComponentContextService],
})
export class LogFormComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        private _logService: LogService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._logService;
        const rowTemplate = <FormControlBase[]>[
            new TextControlSchema({
                field: 'key',
                label: 'Thuộc tính'
            }),
            new TextControlSchema({
                field: 'value',
                label: 'Giá trị'
            })
        ];
        this.setting.schema = <FormControlBase[]>[
            new TextControlSchema({
                field: 'logType',
                label: 'Loại hành động',
                mdWidth: 12,
                required: true
            }),
            new TableSchema({
                field: 'metadata',
                label: 'Metadata',
                mdWidth: 12,
                rowTemplate
                // rows: 8
            }),
            new TextAreaControlSchema({
                field: 'content',
                label: 'Nội dung',
                mdWidth: 12,
                rows: 8
            }),
        ];
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    }

    async onFormEvent(evt) {
        // các event trong form
        console.log(evt);
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
        if (this.model.data.metadata.length) {
            const newObject = {};
            for (const item of this.model.data.metadata) {
                newObject[item.key] = item.value;
            }
            this.model.data.metadata = JSON.stringify(newObject);
        }
    }
}

